import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calculator, FileText, Workflow } from "lucide-react";
import { useTranslation } from "react-i18next";

const PortfolioSection = () => {
  const { t } = useTranslation('portfolio');
  
  const projects = [
    {
      category: "calculators",
      icon: Calculator,
      title: t('projects.0.title'),
      description: t('projects.0.description'),
      popular: Boolean(t('projects.0.popular'))
    },
    {
      category: "calculators",
      icon: Calculator,
      title: t('projects.1.title'), 
      description: t('projects.1.description')
    },
    {
      category: "calculators",
      icon: Calculator,
      title: t('projects.2.title'),
      description: t('projects.2.description')
    },
    {
      category: "forms",
      icon: FileText,
      title: t('projects.3.title'),
      description: t('projects.3.description')
    },
    {
      category: "forms", 
      icon: FileText,
      title: t('projects.4.title'),
      description: t('projects.4.description')
    },
    {
      category: "workflows",
      icon: Workflow,
      title: t('projects.5.title'),
      description: t('projects.5.description')
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Badge variant="outline" className="mb-4">{t('badge')}</Badge>
          <h2 className="text-4xl font-bold mb-6">{t('title')}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('description')}
          </p>
        </div>
        
        <Tabs defaultValue="calculators" className="max-w-6xl mx-auto">
          <TabsList className="grid w-full grid-cols-3 mb-8">
            <TabsTrigger value="calculators">{t('tabs.calculators')}</TabsTrigger>
            <TabsTrigger value="forms">{t('tabs.forms')}</TabsTrigger>
            <TabsTrigger value="workflows">{t('tabs.workflows')}</TabsTrigger>
          </TabsList>
          
          <TabsContent value="calculators">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.filter(p => p.category === "calculators").map((project, index) => {
                const IconComponent = project.icon;
                return (
                  <Card key={index} className="relative hover:shadow-elegant transition-smooth group">
                    {project.popular && (
                      <Badge className="absolute -top-3 left-4 bg-accent text-accent-foreground">
                        {t('popularBadge')}
                      </Badge>
                    )}
                    <CardHeader>
                      <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg mb-4 group-hover:bg-accent group-hover:text-accent-foreground transition-smooth">
                        <IconComponent className="w-6 h-6 text-accent group-hover:text-accent-foreground" />
                      </div>
                      <CardTitle className="text-lg">{project.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription>
                        {project.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </TabsContent>
          
          <TabsContent value="forms">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.filter(p => p.category === "forms").map((project, index) => {
                const IconComponent = project.icon;
                return (
                  <Card key={index} className="hover:shadow-elegant transition-smooth group">
                    <CardHeader>
                      <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg mb-4 group-hover:bg-accent group-hover:text-accent-foreground transition-smooth">
                        <IconComponent className="w-6 h-6 text-accent group-hover:text-accent-foreground" />
                      </div>
                      <CardTitle className="text-lg">{project.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription>
                        {project.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </TabsContent>
          
          <TabsContent value="workflows">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.filter(p => p.category === "workflows").map((project, index) => {
                const IconComponent = project.icon;
                return (
                  <Card key={index} className="hover:shadow-elegant transition-smooth group">
                    <CardHeader>
                      <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg mb-4 group-hover:bg-accent group-hover:text-accent-foreground transition-smooth">
                        <IconComponent className="w-6 h-6 text-accent group-hover:text-accent-foreground" />
                      </div>
                      <CardTitle className="text-lg">{project.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription>
                        {project.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default PortfolioSection;